import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  filterClientsAsync,
  getClientswithFieldsAsync,
} from "../../../../_redux/_services/ClientsSlice";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import {
  getCandidateStatusCustomValues,
  getJobStatusCustomValues,
} from "../../../../_utilities/internalexternalhelper";
import "./AddEditModal.css";
// Images
import {
  getManagerTeamleadAsync,
  getManagerTeamleadStartReducer,
} from "../../../../_redux/_services/JobPostingSlice";
import { BarChart } from "../Images/BarChart";
import { DeliveryOutcomeByClients } from "../Images/DeliveryOutcomeByClients";
import { GraphbyRecruiter } from "../Images/GraphbyRecruiter";
import { GroupByClients } from "../Images/GroupByClients";
import { GroupOfStatus } from "../Images/GroupOfStatus";
import { PieChart } from "../Images/PieChart";
import { RecruiterContributionByStatus } from "../Images/RecruiterContributionByStatus";
import { ResumeContributed } from "../Images/ResumeContributed";
import { Table } from "../Images/Table";
import { TotalResumeContributed } from "../Images/TotalResumeContributed";

import { GetUserId, GetUserInfo } from "../../../../_utilities/getUserInfo";
const AddEditModal = ({
  open,
  submit,
  selectedCard,
  closeDialog,
  widgetTypes,
}) => {
  const dispatch = useDispatch();
  const [widgetTitle, setWidgetTitle] = useState("");
  const [titleError, setTitleError] = useState(false);
  const [selectWidgetError, setSelectWidgetError] = useState(false);
  const [selectStatusError, setSelectStatusError] = useState(false);
  const [selectClientsError, setSelectClientError] = useState(false);
  const [selectRecrutierError, setSelectRecrutierError] = useState(false);
  const [selectMultipleClientsError, setSelectMultipleClientsError] =
    useState(false);
  const [selectedWidget, setSelectedWidget] = useState("");
  const [showStatusTab, setShowStatusTab] = useState(false);
  const [showRecruiterStatus, setShowRecruiterStatus] = useState(false);
  const [showRecruiterCadidateStatus, setShowRecruiterCadidateStatus] =
    useState(false);
  const [showClientsCadidateStatus, setShowClientsCadidateStatus] =
    useState(false);
  const [showClientsJobStatus, setShowClientsJobStatus] = useState(false);
  const [showCadidateClientStatus, setShowCadidateClientStatus] =
    useState(false);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [jobStatusValues, setJobStatusValues] = useState([]);
  const [selectedCandidateStatus, setSelectedCandidateStatus] = useState([]);
  const [selectedJobStatus, setSelectedJobStatus] = useState([]);
  const [recruitersObj, setRecruitersObj] = useState([]);
  const [selectedRecruiterStatus, setSelectedRecruiterStatus] = useState([]);
  const [multipleClientsStatusValues, setMultipleClientsStatusValues] =
    useState([]);
  const [selectedMultipleClientsStatus, setSelectedMultipleClientsStatus] =
    useState([]);
  const [selectedClients, setSelectedClients] = useState({});
  const [appTheme, setTheme] = useState({});
  const [userInfoState, setUserInfoState] = useState(null);
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const clients = useSelector((state) => state.GetClientsWithFields.data);
  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );
  const clientVal = useSelector((state) => state.FilterClients.data);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      const userInfo = await GetUserInfo();
      setUserInfoState(userInfo);
      dispatch(customFieldsAsync(userId));
      dispatch(getClientswithFieldsAsync("customerId"));
      dispatch(getManagerTeamleadAsync(" ", userId));
      const storedTheme = localStorage.getItem("themeSettings");
      if (storedTheme) setTheme(JSON.parse(storedTheme));
    }
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const array = getCandidateStatusCustomValues(customFieldsData);
      setCandidateStatusValues(array);
      const jobStatusArray = getJobStatusCustomValues(customFieldsData);
      setJobStatusValues(jobStatusArray);
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (selectedCard) {
      setWidgetTitle(selectedCard.title);
      const widget = widgetTypes.find(
        (item) => item.type === selectedCard.type,
      );
      setSelectedWidget(widget || null);
      setSelectedClients(selectedCard?.client);
      setSelectedMultipleClientsStatus(selectedCard?.client);
      setSelectedCandidateStatus(selectedCard?.status);
      setSelectedJobStatus(selectedCard?.status);
      setSelectedRecruiterStatus(selectedCard?.recruiters);
    }
  }, [selectedCard, widgetTypes]);

  useEffect(() => {
    if (clientVal && clientVal.length > 0) {
      let clientValue = JSON.parse(JSON.stringify(clientVal));
      let ClientData = [];
      clientValue.forEach((e) => {
        if (e.status === "Active") {
          e.clientName = e.clientName;
          ClientData.push(e);
        }
      });
      setMultipleClientsStatusValues(ClientData);
    } else {
      dispatch(filterClientsAsync(""));
    }
  }, [clientVal]);

  const handleWidgetSelection = (e, newValue) => {
    const widget = widgetTypes.find((item) => item.type === newValue?.type);
    setSelectedWidget(widget);
    if (selectWidgetError && newValue?.title?.trim()) {
      setSelectWidgetError(false);
    }
  };

  useEffect(() => {
    if (recruiterList && recruiterList.length > 0) {
      const data = JSON.parse(JSON.stringify(recruiterList));
      let newArray = [];
      data.forEach((list) => {
        let obj = {
          id: list.id.toString(),
          name: `${list.firstName} ${list.lastName}`,
          emailId: list.emailId,
        };
        newArray.push(obj);
      });
      setRecruitersObj(newArray);
      dispatch(getManagerTeamleadStartReducer({}));
    }
  }, [recruiterList]);

  const handleTitleChange = (title) => {
    if (titleError && title?.trim()) {
      setTitleError(false);
    }
    setWidgetTitle(title);
  };

  const proceedToStatusSection = () => {
    setTitleError(false);
    setSelectWidgetError(false);
    setShowStatusTab(false);
    setShowRecruiterStatus(false);
    setShowRecruiterCadidateStatus(false);
    setShowClientsCadidateStatus(false);
    setShowClientsJobStatus(false);
    setShowCadidateClientStatus(false);
    if (
      widgetTitle &&
      (selectedWidget?.showStatus || selectedWidget?.showClient)
    ) {
      setShowStatusTab(true);
    } else if (widgetTitle && selectedWidget?.showRecruiterOnly) {
      setShowRecruiterStatus(true);
    } else if (
      widgetTitle &&
      selectedWidget?.showRecruiter &&
      selectedWidget?.showCadidateStatus
    ) {
      setShowRecruiterCadidateStatus(true);
    } else if (
      widgetTitle &&
      selectedWidget.type === "DeliveryOutcomeByClients" &&
      selectedWidget?.showClients &&
      selectedWidget?.showCadidateStatus
    ) {
      setShowClientsCadidateStatus(true);
    } else if (
      widgetTitle &&
      selectedWidget.type === "JobStatusByClient" &&
      selectedWidget?.showClients &&
      selectedWidget?.showJobStatus
    ) {
      setShowClientsJobStatus(true);
    } else if (
      widgetTitle &&
      selectedWidget.type === "candidateDetailsByStatus" &&
      selectedWidget?.showClients &&
      selectedWidget?.showCadidateStatus
    ) {
      setShowCadidateClientStatus(true);
    } else if (widgetTitle && selectedWidget.type) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        client: selectedClients,
        status: selectedCandidateStatus,
      });
    } else {
      if (!widgetTitle || !widgetTitle?.trim()) {
        setTitleError(true);
      }

      if (!selectedWidget?.type) {
        setSelectWidgetError(true);
      }
    }
  };

  const handleStatusSelection = (value) => {
    const arr = Array.isArray(value) ? value : [];
    setSelectedCandidateStatus(arr);
    if (!showCadidateClientStatus) {
      setSelectStatusError(arr.length === 0);
    } else {
      setSelectStatusError(false);
    }
  };

  const handleJobStatusSelection = (value) => {
    const arr = Array.isArray(value) ? value : [];
    setSelectedJobStatus(arr);
    if (!showClientsJobStatus) {
      setSelectStatusError(arr.length === 0);
    } else {
      setSelectStatusError(false);
    }
  };

  const handleRecruiterSelection = (value) => {
    const arr = Array.isArray(value) ? value : [];
    setSelectedRecruiterStatus(arr);
    setSelectRecrutierError(arr.length === 0);
  };

  const handleMultipleClientSelection = (value) => {
    const arr = Array.isArray(value) ? value : [];
    setSelectedMultipleClientsStatus(arr);
    setSelectMultipleClientsError(arr.length === 0);
  };

  const handleClientSelection = (value) => {
    // value can be either the selected option object (from Autocomplete)
    // or an id (legacy usage). Normalize to the client object.
    let widget = null;
    if (!value) {
      // cleared selection
      setSelectedClients({});
      setSelectClientError(true);
      return;
    }

    if (typeof value === "object" && value.id) {
      widget = value;
    } else {
      widget = clients?.find((item) => item.id === value);
    }
    if (widget) {
      setSelectedClients(widget);
      setSelectClientError(false);
    } else {
      setSelectClientError(true);
    }
  };

  const proceedToSave = () => {
    setSelectStatusError(false);
    setSelectClientError(false);
    const candidateCount = Array.isArray(selectedCandidateStatus)
      ? selectedCandidateStatus.length
      : 0;
    const multipleClientsCount = Array.isArray(selectedMultipleClientsStatus)
      ? selectedMultipleClientsStatus.length
      : 0;
    const recruiterCount = Array.isArray(selectedRecruiterStatus)
      ? selectedRecruiterStatus.length
      : 0;

    if (
      widgetTitle?.trim() &&
      ((selectedWidget.type === "GraphbyClient" &&
        selectedClients?.id &&
        candidateCount) ||
        ((selectedWidget?.type === "GraphofStatus" ||
          selectedWidget?.type === "ResumeCount") &&
          candidateCount))
    ) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        client: selectedClients,
        status: selectedCandidateStatus,
      });
    } else if (
      widgetTitle?.trim() &&
      selectedWidget?.type === "GraphbyRecruiter" &&
      selectedRecruiterStatus.length
    ) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        recruiters: selectedRecruiterStatus,
      });
    } else if (
      widgetTitle?.trim() &&
      selectedWidget?.type === "RecruiterContributionByStatus" &&
      selectedRecruiterStatus.length &&
      selectedCandidateStatus.length
    ) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        recruiters: selectedRecruiterStatus,
        status: selectedCandidateStatus,
      });
    } else if (
      widgetTitle?.trim() &&
      selectedWidget?.type === "DeliveryOutcomeByClients" &&
      selectedMultipleClientsStatus.length &&
      selectedCandidateStatus.length
    ) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        client: selectedMultipleClientsStatus,
        status: selectedCandidateStatus,
      });
    } else if (
      widgetTitle?.trim() &&
      selectedWidget?.type === "JobStatusByClient" &&
      selectedClients &&
      selectedJobStatus.length
    ) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        client: selectedClients,
        status: selectedJobStatus,
      });
    } else if (
      widgetTitle?.trim() &&
      selectedWidget?.type === "candidateDetailsByStatus" &&
      selectedCandidateStatus.length
    ) {
      submit({
        ...selectedCard,
        ...selectedWidget,
        title: widgetTitle,
        client: selectedMultipleClientsStatus,
        status: selectedCandidateStatus,
      });
    } else {
      if (!selectedClients || !selectedClients.clientName) {
        setSelectClientError(true);
      }
      if (!widgetTitle || !widgetTitle?.trim()) {
        setTitleError(true);
      }
      if (!candidateCount) {
        setSelectStatusError(true);
      }
      if (!recruiterCount) {
        setSelectRecrutierError(true);
      }
      if (!multipleClientsCount) {
        setSelectMultipleClientsError(true);
      }
    }
  };

  const handleClose = () => {
    closeDialog(false);
  };

  const showOnlyStatus = () => {
    return (
      <div className="status-container">
        <FormControl fullWidth>
          <InputLabel className="boldSelectlabel" shrink={true}>
            Select Status
          </InputLabel>
          {/* Searchable, multi-select Autocomplete for candidate status */}
          <Autocomplete
            multiple
            limitTags={4}
            options={candidateStatusValues || []}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.internal || ""}
            getOptionKey={(option) => option.id}
            value={candidateStatusValues.filter((opt) =>
              selectedCandidateStatus.includes(opt.id),
            )}
            onChange={(e, newValue) =>
              handleStatusSelection(newValue.map((v) => v.id))
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            className="select-widget"
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                <Checkbox
                  checked={selectedCandidateStatus.indexOf(option.id) > -1}
                  style={{ marginRight: 8 }}
                />
                <ListItemText primary={option.internal} />
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                error={selectStatusError}
              />
            )}
            renderTags={(value, getTagProps) => {
              const maxToShow = 3;
              return (
                <>
                  {value.slice(0, maxToShow).map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id}
                      label={option.internal}
                    />
                  ))}

                  {value.length > maxToShow && (
                    <Chip
                      key="more-chip"
                      label={`+${value.length - maxToShow} more`}
                    />
                  )}
                </>
              );
            }}
          />
        </FormControl>
      </div>
    );
  };

  const showClientAndStatus = () => {
    return (
      <>
        <div className="form-div">
          <FormControl fullWidth>
            {/* Searchable dropdown using MUI Autocomplete */}
            <InputLabel className="boldSelectlabel" shrink={true}>
              Client Name
            </InputLabel>
            <Autocomplete
              options={clients || []}
              getOptionLabel={(option) => option?.clientName || ""}
              getOptionKey={(option) => option.id}
              value={
                selectedClients && selectedClients.id ? selectedClients : null
              }
              onChange={(e, newValue) => handleClientSelection(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectClientsError}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.clientName}
                </li>
              )}
              disableClearable={false}
            />
          </FormControl>
        </div>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Select Status
            </InputLabel>
            <Autocomplete
              multiple
              options={candidateStatusValues || []}
              disableCloseOnSelect
              getOptionKey={(option) => option.id}
              getOptionLabel={(option) => option?.internal || ""}
              value={candidateStatusValues.filter((opt) =>
                selectedCandidateStatus.includes(opt.id),
              )}
              onChange={(e, newValue) =>
                handleStatusSelection(newValue.map((v) => v.id))
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;
                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.internal}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip label={`+${value.length - maxToShow} more`} />
                    )}
                  </>
                );
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <Checkbox
                    checked={selectedCandidateStatus.indexOf(option.id) > -1}
                    style={{ marginRight: 8 }}
                  />
                  <ListItemText primary={option.internal} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectStatusError}
                />
              )}
            />
          </FormControl>
        </div>
      </>
    );
  };

  const showClientsAndJobStatus = () => {
    return (
      <>
        <div className="form-div">
          <FormControl fullWidth>
            {/* Searchable dropdown using MUI Autocomplete */}
            <InputLabel className="boldSelectlabel" shrink={true}>
              Client Name
            </InputLabel>
            <Autocomplete
              options={clients || []}
              getOptionLabel={(option) => option?.clientName || ""}
              getOptionKey={(option) => option.id}
              value={
                selectedClients && selectedClients.id ? selectedClients : null
              }
              onChange={(e, newValue) => handleClientSelection(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectClientsError}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.clientName}
                </li>
              )}
              disableClearable={false}
            />
          </FormControl>
        </div>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Select Status
            </InputLabel>
            <Autocomplete
              multiple
              options={jobStatusValues || []}
              disableCloseOnSelect
              getOptionKey={(option) => option.id}
              getOptionLabel={(option) => option?.internal || ""}
              value={jobStatusValues.filter((opt) =>
                selectedJobStatus.includes(opt),
              )}
              onChange={(e, newValue) => handleJobStatusSelection(newValue)}
              isOptionEqualToValue={(option, value) => option === value}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;
                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option}
                        label={option}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip label={`+${value.length - maxToShow} more`} />
                    )}
                  </>
                );
              }}
              renderOption={(props, option) => (
                <li {...props} key={option}>
                  <Checkbox
                    checked={selectedJobStatus.indexOf(option) > -1}
                    style={{ marginRight: 8 }}
                  />
                  <ListItemText primary={option} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectStatusError}
                />
              )}
            />
          </FormControl>
        </div>
      </>
    );
  };

  const showRecruiterAndCadidateStatus = () => {
    return (
      <>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Recruiter Name
            </InputLabel>
            <Autocomplete
              multiple
              options={recruitersObj || []}
              disableCloseOnSelect
              getOptionLabel={(option) => option?.name || ""}
              getOptionKey={(option) => option.id}
              value={recruitersObj.filter((opt) =>
                selectedRecruiterStatus.includes(opt.id),
              )}
              onChange={(e, newValue) =>
                handleRecruiterSelection(newValue.map((v) => v.id))
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <ListItemText primary={option.name} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectRecrutierError}
                />
              )}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;

                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.name}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip label={`+${value.length - maxToShow} more`} />
                    )}
                  </>
                );
              }}
            />
            {/* <FormHelperText>{formik.errors.portal && formik.touched.portal ? formik.errors.portal : ""}</FormHelperText> */}
          </FormControl>
        </div>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Candidate Status
            </InputLabel>
            <Autocomplete
              multiple
              options={candidateStatusValues || []}
              disableCloseOnSelect
              getOptionLabel={(option) => option?.internal || ""}
              getOptionKey={(option) => option.id}
              value={candidateStatusValues.filter((opt) =>
                selectedCandidateStatus.includes(opt.id),
              )}
              onChange={(e, newValue) =>
                handleStatusSelection(newValue.map((v) => v.id))
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <Checkbox
                    checked={selectedCandidateStatus.indexOf(option.id) > -1}
                    style={{ marginRight: 8 }}
                  />
                  <ListItemText primary={option.internal} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectStatusError}
                />
              )}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;

                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.internal}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip label={`+${value.length - maxToShow} more`} />
                    )}
                  </>
                );
              }}
            />
          </FormControl>
        </div>
      </>
    );
  };

  const showRecruiterStatusUI = () => {
    return (
      <>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Recruiter Name
            </InputLabel>
            <Autocomplete
              multiple
              options={recruitersObj || []}
              disableCloseOnSelect
              getOptionLabel={(option) => option?.name || ""}
              getOptionKey={(option) => option.id}
              value={recruitersObj.filter((opt) =>
                selectedRecruiterStatus.includes(opt.id),
              )}
              onChange={(e, newValue) =>
                handleRecruiterSelection(newValue.map((v) => v.id))
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <ListItemText primary={option.name} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectRecrutierError}
                />
              )}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;

                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.name}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip label={`+${value.length - maxToShow} more`} />
                    )}
                  </>
                );
              }}
            />

            {/* <Select
                  className="applicationfieldcss"
                  name="portal"
                  autoComplete="off"
                  labelId="demo-multiple-chip-label1"
                  id=""
                  error={selectRecrutierError}
                  multiple
                  value={selectedRecruiterStatus}
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: 320 },
                    },
                  }}
                  onChange={(e) => handleRecruiterSelection(e.target.value)}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => {
                        let obj = recruitersObj.filter((x) => x.id === value)[0];
                        if(obj){
                          return <Chip key={obj.name} label={obj.name} />;
                        }
                      })}
                    </Box>
                  )}
                >
                  {recruitersObj && recruitersObj.length > 0 && recruitersObj.map((list) => (
                    <MenuItem className="selectOptions" key={list.id} value={list.id}>
                      {list.name}
                    </MenuItem>
                  ))}
                </Select> */}
            {/* <FormHelperText>{formik.errors.portal && formik.touched.portal ? formik.errors.portal : ""}</FormHelperText> */}
          </FormControl>
        </div>
      </>
    );
  };

  const showClientsAndCadidateStatus = () => {
    return (
      <>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Client Name
            </InputLabel>
            <Autocomplete
              multiple
              limitTags={2}
              options={multipleClientsStatusValues || []}
              disableCloseOnSelect
              getOptionLabel={(option) => option?.clientName || ""}
              getOptionKey={(option) => option.id}
              value={multipleClientsStatusValues.filter((opt) =>
                selectedMultipleClientsStatus.includes(opt.id),
              )}
              onChange={(e, newValue) =>
                handleMultipleClientSelection(newValue.map((v) => v.id))
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <ListItemText primary={option.clientName} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectMultipleClientsError}
                />
              )}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;
                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.clientName}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip
                        key="more-chip"
                        label={`+${value.length - maxToShow} more`}
                      />
                    )}
                  </>
                );
              }}
            />

            {/* <Select
                  className="applicationfieldcss"
                  name="portal"
                  autoComplete="off"
                  labelId="demo-multiple-chip-label1"
                  id=""
                  error={selectMultipleClientsError}
                  multiple
                  value={selectedMultipleClientsStatus}
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: 320 },
                    },
                  }}
                  onChange={(e) => {handleMultipleClientSelection(e.target.value)}}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => {
                        let obj = multipleClientsStatusValues.filter((x) => x.id === value)[0];
                        if(obj){
                          return <Chip key={obj.clientName} label={obj.clientName} />;
                        }
                      })}
                    </Box>
                  )}
                >
                  {multipleClientsStatusValues.map(list => (
                    <MenuItem
                      className="selectOptions"
                      key={list.id}
                      value={list.id}
                    >
                      {list.clientName}
                    </MenuItem>
                  ))}
                </Select> */}
            {/* <FormHelperText>{formik.errors.portal && formik.touched.portal ? formik.errors.portal : ""}</FormHelperText> */}
          </FormControl>
        </div>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Candidate Status
            </InputLabel>
            <Autocomplete
              multiple
              limitTags={2}
              options={candidateStatusValues || []}
              disableCloseOnSelect
              getOptionLabel={(option) => option?.internal || ""}
              value={candidateStatusValues.filter((opt) =>
                selectedCandidateStatus.includes(opt.id),
              )}
              onChange={(e, newValue) =>
                handleStatusSelection(newValue.map((v) => v.id))
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="select-widget"
              ListboxProps={{
                style: { maxHeight: "250px" },
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <Checkbox
                    checked={selectedCandidateStatus.indexOf(option.id) > -1}
                    style={{ marginRight: 8 }}
                  />
                  <ListItemText primary={option.internal} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={selectStatusError}
                />
              )}
              renderTags={(value, getTagProps) => {
                const maxToShow = 1;

                return (
                  <>
                    {value.slice(0, maxToShow).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.internal}
                      />
                    ))}

                    {value.length > maxToShow && (
                      <Chip
                        key="more-chip"
                        label={`+${value.length - maxToShow} more`}
                      />
                    )}
                  </>
                );
              }}
            />
          </FormControl>
        </div>
      </>
    );
  };

  const showCadidateAndClientStatus = () => {
    return (
      <>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Candidate Status
            </InputLabel>
            <Select
              className="select-widget"
              error={selectStatusError}
              onChange={(e) => handleStatusSelection(e.target.value)}
              multiple
              value={selectedCandidateStatus}
              renderValue={(selected) =>
                selected
                  .map(
                    (id) =>
                      candidateStatusValues.find((option) => option.id === id)
                        ?.internal,
                  )
                  .join(", ")
              }
              MenuProps={{
                PaperProps: {
                  className: "dashBoardDropdownStatusvalues",
                  style: { maxHeight: 320 },
                },
              }}
            >
              {candidateStatusValues.map((widget) => (
                <MenuItem key={widget.id} value={widget.id}>
                  <Checkbox
                    checked={selectedCandidateStatus.indexOf(widget.id) > -1}
                  />
                  <ListItemText primary={widget.internal} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="form-div">
          <FormControl fullWidth>
            <InputLabel className="boldSelectlabel" shrink={true}>
              Client Name (optional)
            </InputLabel>
            <Select
              className="applicationfieldcss"
              name="portal"
              autoComplete="off"
              labelId="demo-multiple-chip-label1"
              multiple
              value={selectedMultipleClientsStatus}
              MenuProps={{
                PaperProps: {
                  style: { maxHeight: 320 },
                },
              }}
              onChange={(e) => {
                handleMultipleClientSelection(e.target.value);
              }}
              renderValue={(selected) => {
                const maxToShow = 2;
                const selectedObjects = selected
                  .map((id) =>
                    multipleClientsStatusValues.find((x) => x.id === id),
                  )
                  .filter(Boolean);

                return (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selectedObjects.slice(0, maxToShow).map((obj) => (
                      <Chip key={obj.id} label={obj.clientName} />
                    ))}
                    {selectedObjects.length > maxToShow && (
                      <Chip
                        key="more-chip"
                        label={`+${selectedObjects.length - maxToShow} more`}
                      />
                    )}
                  </Box>
                );
              }}
            >
              {multipleClientsStatusValues.map((list) => (
                <MenuItem
                  className="selectOptions"
                  key={list.id}
                  value={list.id}
                >
                  {list.clientName}
                </MenuItem>
              ))}
            </Select>
            {/* <FormHelperText>{formik.errors.portal && formik.touched.portal ? formik.errors.portal : ""}</FormHelperText> */}
          </FormControl>
        </div>
      </>
    );
  };

  const getSampleImage = (type) => {
    const isRecruiter = !!(
      userInfoState && userInfoState[0]?.teamRoles === "Recruiter"
    );
    const isManager = !!(
      userInfoState &&
      (userInfoState[0]?.teamRoles === "Manager" ||
        userInfoState[0]?.teamRoles === "Team Lead")
    );

    if (!type) return null;
    switch (type) {
      case "GraphofStatus":
        return (
          <GroupOfStatus
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
          />
        );
      case "GraphbyClient":
        return (
          <GroupByClients
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
          />
        );
      case "JobStatusByClient":
        return (
          <GroupByClients
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
          />
        );
      case "ResumeCount":
        return (
          <ResumeContributed
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
            secondaryColor={appTheme?.secondaryColor}
          />
        );
      case "TotalUploadedResumes":
        return (
          <TotalResumeContributed
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
            secondaryColor={appTheme?.secondaryColor}
          />
        );
      case "pieChart":
        return (
          <PieChart
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
            isRecruiter={isRecruiter}
          />
        );
      case "barChart":
        return (
          <BarChart
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
            isRecruiter={isRecruiter}
          />
        );
      case "requirementsWidget":
        return (
          <Table
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
            secondaryColor={appTheme?.secondaryColor}
            isRecruiter={isRecruiter}
            isManager={isManager}
          />
        );
      case "candidateDetailsByStatus":
        return (
          <Table
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
            secondaryColor={appTheme?.secondaryColor}
            isRecruiter={isRecruiter}
          />
        );
      case "GraphbyRecruiter":
        return (
          <GraphbyRecruiter
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
          />
        );
      case "RecruiterContributionByStatus":
        return (
          <RecruiterContributionByStatus
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
          />
        );
      case "DeliveryOutcomeByClients":
        return (
          <DeliveryOutcomeByClients
            primaryColor={appTheme?.primaryColor}
            primaryFontColor={appTheme?.primaryFontColor}
          />
        );
      default:
        return null;
    }
  };

  const showImgAndDescription = () => {
    return (
      <>
        {selectedWidget.description && (
          <div className="message-text">{selectedWidget.description}</div>
        )}
        <div className="sample-img-container">
          {getSampleImage(selectedWidget.type)}
        </div>
      </>
    );
  };

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={closeDialog}
      aria-describedby="alert-dialog"
      className="add-dialouge"
    >
      <Box>
        <DialogTitle className="diabtn">
          {selectedCard ? "Edit Widget" : "New Widget"}
          <img
            src={process.env.PUBLIC_URL + "/assests/img/close.svg"}
            alt=""
            className="closeicon-modelpopup"
            onClick={() => handleClose()}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Box className="form-container">
            <div className="form-div">
              <FormControl fullWidth>
                <InputLabel className="boldSelectlabel" shrink={true}>
                  Select Widget
                </InputLabel>
                <Autocomplete
                  options={widgetTypes}
                  size="small"
                  className="select-Widget-dropdown"
                  error={selectWidgetError}
                  disableClearable
                  value={
                    selectedWidget && selectedWidget.title
                      ? selectedWidget
                      : null
                  }
                  getOptionLabel={(option) => option.title}
                  renderValue={(selected) => selected}
                  disabled={
                    showStatusTab ||
                    showRecruiterCadidateStatus ||
                    showClientsCadidateStatus ||
                    showClientsJobStatus ||
                    showCadidateClientStatus ||
                    showRecruiterStatus ||
                    selectedCard?.i
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.type === value.type
                  }
                  onChange={handleWidgetSelection}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <img
                        src={option.imageIcon}
                        alt={option.title}
                        style={{ width: 20, height: 20, objectFit: "contain" }}
                      />
                      <span>{option.title}</span>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      error={selectWidgetError}
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: 1.4,
                        maxWidth: "270px",
                      }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedWidget ? (
                          <InputAdornment
                            position="start"
                            sx={{ marginRight: 1 }}
                          >
                            <img
                              src={selectedWidget.imageIcon}
                              alt={selectedWidget.title}
                              style={{
                                width: 20,
                                height: 20,
                                objectFit: "contain",
                              }}
                            />
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  )}
                />
              </FormControl>
            </div>
            <div className="form-div">
              <FormControl fullWidth>
                <InputLabel className="boldSelectlabel" shrink={true}>
                  Widget Name
                </InputLabel>
                <TextField
                  fullWidth
                  value={widgetTitle}
                  variant="outlined"
                  disabled={showStatusTab}
                  error={titleError} // Indicates an error visually
                  onChange={(e) => handleTitleChange(e.target.value)}
                />
              </FormControl>
            </div>
            {showStatusTab &&
              selectedWidget.showStatus &&
              !selectedWidget.showClient &&
              showOnlyStatus()}
            {showStatusTab &&
              selectedWidget.showStatus &&
              selectedWidget.showClient &&
              showClientAndStatus()}
            {showRecruiterStatus && showRecruiterStatusUI()}
            {showRecruiterCadidateStatus && showRecruiterAndCadidateStatus()}
            {showClientsCadidateStatus && showClientsAndCadidateStatus()}
            {showClientsJobStatus && showClientsAndJobStatus()}
            {showCadidateClientStatus && showCadidateAndClientStatus()}
          </Box>
          <Box className="message-container">
            {selectedWidget &&
              !showStatusTab &&
              !showRecruiterCadidateStatus &&
              !showClientsCadidateStatus &&
              !showClientsJobStatus &&
              !showRecruiterStatus &&
              !showCadidateClientStatus &&
              showImgAndDescription()}
          </Box>
        </DialogContent>
        <DialogActions className="actions-container">
          {!showStatusTab &&
          !showRecruiterCadidateStatus &&
          !showClientsCadidateStatus &&
          !showClientsJobStatus &&
          !showRecruiterStatus &&
          !showCadidateClientStatus ? (
            <Button
              variant="contained"
              onClick={proceedToStatusSection}
              className="dialog-button"
            >
              {[
                "Candidate Status Distribution",
                "Individual Performance by Resume Upload",
                "Requirements Tracker",
                "Resume Upload Sources",
              ].includes(selectedWidget.title)
                ? "Save"
                : "Continue"}
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={proceedToSave}
              className="dialog-button"
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default React.memo(AddEditModal);
